import { mapper } from '../../../mapper';

/**
 * inserta el modelo del view (ej. 'CAB') si el campo de la dependencia no empieza por el (ej. 'CABECERA.CAMPO' -> 'CAB.CABECERA.CAMPO')
 *
 * @param {string} viewModel el modelo base, ej 'CAB'
 * @returns {Function}
 */
export function fixModelFactory(viewModel) {
  if (!viewModel) {
    return view => view;
  }

  /**
   *
   */
  return view => {
    return mapper(view, property => {
      if (property.model /*&& property.model !== viewModel*/ && !property.model.startsWith(`${viewModel.split('.')[0]}.`)) {
        // @odeniel el '.' para incluir 'CABLOQUESEA' -> 'CAB.CABLOQUESEA'
        property.model = `${viewModel}.${property.model}`;
      }

      return property;
    });
  };
}
